import { forwardRef, type ButtonHTMLAttributes } from 'react';

// Variants semánticos del proyecto (norma del CEO 2026-05-20):
//   edit   → mostaza/amarillo  (Editar)
//   save   → verde             (Guardar)
//   create → azul              (+ Nuevo, Crear, Añadir)
//   danger → rojo              (Cancelar, Eliminar)
//   primary/secondary/ghost se mantienen para acciones neutras.
type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'edit' | 'save' | 'create';
type Size = 'sm' | 'md';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
};

const variantClass: Record<Variant, string> = {
  primary: 'bg-slate-900 text-white hover:bg-slate-800 focus:ring-slate-900',
  secondary: 'bg-white text-slate-900 border border-slate-300 hover:bg-slate-50 focus:ring-slate-500',
  ghost: 'text-slate-700 hover:bg-slate-100 focus:ring-slate-400',
  danger: 'bg-rose-600 text-white hover:bg-rose-500 focus:ring-rose-500',
  edit: 'bg-amber-500 text-white hover:bg-amber-400 focus:ring-amber-500',
  save: 'bg-emerald-600 text-white hover:bg-emerald-500 focus:ring-emerald-600',
  create: 'bg-blue-600 text-white hover:bg-blue-500 focus:ring-blue-600',
};

const sizeClass: Record<Size, string> = {
  sm: 'px-2.5 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', size = 'md', className = '', disabled, ...props },
  ref,
) {
  const cls = `inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition focus:outline-none focus:ring-2 focus:ring-offset-1 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 ${variantClass[variant]} ${sizeClass[size]} ${className}`;
  return <button ref={ref} className={cls} disabled={disabled} {...props} />;
});
